import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import '@foundit/footer/dist/FooterWeb.css';
import '@foundit/header/dist/HeaderWeb.css';
import HeaderWeb from '@foundit/header/dist/HeaderWeb';
import { FooterWeb } from '@foundit/footer/dist/FooterWeb';
import type { HeaderWebRef } from '@foundit/header/dist/HeaderWeb';
import { MIDDLEWARE } from './constants/api';
import RecruiterHeader from "@foundit/recruiterHeader";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


const RootComponent = () => {
  const headerRef = useRef<HeaderWebRef>(null);
useEffect(()=>{window.__globalHeaderRef__ = headerRef;},[])
  return (
    <Provider store={store}>
      <RecruiterHeader
        environment={
          process.env.NEXT_PUBLIC_CT_PROD_PROJECT_ID ||
          process.env.NEXT_PUBLIC_CT_TEST_PROJECT_ID ||
          "TEST-944-RZ9-9Z7Z"
        }
        page_name={"Dashboard page"}
        page={"DBP"}
        // middleware={""}
        ref={headerRef}
        isClevertapOn={true}
        // isRecallGetUser={true} //true if u want to call get user api every reload other wise will get it from session
        showBetaTag={false}
        isLoggedIn
        subContainerStyles={{ maxWidth: "unset", padding: "0 16px 0 16px" }}
        hideQuickSearch={true}
      />
      <div style={{ marginBottom: 60,position:"relative" }}>
        <App />
      </div>
      <div style={{ position: 'fixed', bottom: 0, width: '100%' }}>
        <FooterWeb />
      </div>
    </Provider>
  );
};

root.render(
  <React.StrictMode>
    <RootComponent />
  </React.StrictMode>
);

reportWebVitals();
